import React from 'react'
import "./setupDetails.scss"

import { SetupBoardContext } from '../SetupBoard/SetupBoard';
import OnboardingItemIntro from '../SetupDetailsUtilities/OnboardingItemIntro'
// import { basicsetupDetailsData } from './BasicSetupDetails/data'
// import { coursesSetupDetailsData } from './CoursesSetupDetails/data'
// import { inviteMembersSetupDetailssData } from './InviteMembersSetupDetails/data'
// import { subscriptionSetupDetailsData } from './SubscriptionSetupDetails/data'
// import { communitysetupDetailsData } from './CommunitySetupDetails/data'

export interface ISetupChecklist {
    selected: number
    groupData: any
}

const SetupDetails: React.FC<ISetupChecklist> = ({ selected, groupData }) => {

    const { isPopup } = React.useContext(SetupBoardContext)

    // const checklistItems = [
    //     {
    //         text: "Welcome", selected: 5, title: 'Welcome To GroupApp', description: 'Get familiar with GroupApp by watching our quick overview video.',
    //         dataLength: basicsetupDetailsData.length
    //     },
    //     {
    //         text: "Basic Setup", selected: 0, title: 'Basic Setup', description: 'Learn how to set up your community profile and branding.',
    //         dataLength: basicsetupDetailsData.length
    //     },
    //     {
    //         text: "Community", selected: 1, title: 'Create A Community', description: 'Set up the key elements of your community.',
    //         dataLength: communitysetupDetailsData.length
    //     },
    //     {
    //         text: "Courses", selected: 4, title: 'Create A Course', description: 'Create public, private, or paid courses in your community.',
    //         dataLength: coursesSetupDetailsData.length
    //     },
    //     {
    //         text: "Subscriptions", selected: 2, title: 'Subscriptions', description: 'Set up recurring subscriptions to access your community and content.',
    //         dataLength: subscriptionSetupDetailsData.length
    //     },
    //     {
    //         text: "Onboarding Setup", selected: 3, title: 'Onboarding Setup', description: 'Customize your community onboarding, and add your first members.',
    //         dataLength: inviteMembersSetupDetailssData.length
    //     },
    // ];

    return (
        <div className='setup-details-wrapper'>
            {isPopup &&
                <div className='setup-details-wrapper-ul'>
                    {/* {checklistItems.map((item) => (
                    ))} */}
                    {/* <li className='setup-details-wrapper-ul'> */}
                            <OnboardingItemIntro
                        title={''}
                        description={''}
                                groupData={groupData}
                        itemsLength={0}
                        compSelected={''}
                            />
                    {/* </li> */}

                </div>
            }

        </div>
    )
}

export default SetupDetails
